import React, { Component } from 'react';

class GridBooleanCellTemplate extends Component {
    constructor(props){
        super();
        
        this.props = props;
    }

    render(){
        return (
            <td>
                <div className="type--center">
                    {this.props.dataItem[this.props.field] ?        
                        <i className= {this.props.displayRedIcon ? "u-icon u-icon--sml u-icon--active-red" : "u-icon u-icon--sml u-icon--active"}></i> :          
                        (this.props.displayFaultyValue ?  <i className="u-icon u-icon--sml u-icon--inactive"></i>  : null)
                    }
                </div>
            </td>
        );
    }
}

export default GridBooleanCellTemplate;